import React from 'react'

import FullScreen from 'lib/components/full-screen'

import Filters from './filters'

export default function FiltersPage () {
  return (
    <div className='search-page with-mobile-header no-top-padding'>
      <div className='filter-fullscreen-mode' id='main-all-filter'>
        <FullScreen />
        <Filters fullScreenFiltersPage />
      </div>
    </div>
  )
}
